export default __webpack_public_path__ + "static/media/2.aa73abb1.png";